import { termsUrls } from '@avalara/bat-apps-shared/constants';
import { t, translate } from '@avalara/bat-apps-shared/i18n';
import IframePaymentContainer from '../containers/iframe-payment-container';
import ExistingPaymentMethodNotice from './shared/payment/existing-payment-method-notice';
import { LightBoxOutline } from './styled/skylab/box';
import { RelativeDiv } from './styled/skylab/page';

type Props = {
  hideIframe: boolean;
  isHighRadius?: boolean;
  onHighRadiusSubmit?: () => void;
};

const PaymentAuthorizationDisclosures = () => (
  <LightBoxOutline>
    <p className='font-italic'>{t('client.general.your-payment-method-will-be-used-for-automatic-payment-of-al')}</p>
    <p className='font-italic'>{t('client.general.keep-in-mind')}:</p>
    <ul>
      <li className='font-italic'>{t('client.payment.authorization-text')}</li>
      <li className='font-italic'>
        {t('client.general.we-will-automatically-charge-your-payment-method-on-the-invo')}
      </li>
      <li className='font-italic'>{t('client.general.you-can-update-your-payment-method-at-any-time')}</li>
      <li className='font-italic'>
        {translate('client.payment.cancellation-terms', {
          cancellationUrl: 'https://knowledge.avalara.com/cancellation',
          termsLabel: t('client.general.avalara-service-terms-and-conditions-1'),
          termsLink: (chunks) => <a href={termsUrls.general}>{chunks}</a>,
          cancellationLink: (chunks) => <a href='https://knowledge.avalara.com/cancellation'>{chunks}</a>,
        })}
      </li>
    </ul>
  </LightBoxOutline>
);

const Payment = ({ hideIframe, isHighRadius, onHighRadiusSubmit }: Props) => (
  <div>
    <h3 className='pad-left-md'>{t('client.headings.payment-method')}</h3>
    {isHighRadius ? (
      <>
        <ExistingPaymentMethodNotice />
        <PaymentAuthorizationDisclosures />
        <button type='button' className='primary margin-top-md' onClick={onHighRadiusSubmit}>
          {t('client.buttons.buy-now')}
        </button>
      </>
    ) : (
      <RelativeDiv>
        <IframePaymentContainer hideIframe={hideIframe} />

        <PaymentAuthorizationDisclosures />
      </RelativeDiv>
    )}
  </div>
);

export default Payment;
